import { DesignData } from 'src/store/design/types';
import graphqlClient from './graphqlClient';

export interface FlatPreview {
  url: string;
  thumbnailUrl: string;
  spreadIndex: number | undefined;
}

export interface DesignPreviews {
  flat?: FlatPreview[];
  the3d?: { url: string };
}

export interface PreviewTypeAvailability {
  flat: boolean;
  the3d: boolean;
  image: boolean;
  scene: boolean;
}

export type PreviewExportType = 'flat' | 'flat-advanced' | '3d' | 'mockup';

export type SceneCategories = 'all' | 'editor';

/**
 * Service for design renders GraphQL operations
 */
class DesignRendersService {
  private readonly moduleName = 'designEditor';

  /**
   * Get design renders from the dashboard GraphQL API
   */
  async getRenders(
    designStructure: DesignData,
    removeSamples: boolean,
    sceneCategories: SceneCategories = 'editor',
    premiumSceneSize = 800,
  ): Promise<DesignPreviews | null> {
    const operation = 'designRenders';

    const query = `
      query(
        $designStructure: JSONObject!,
        $assets: JSONObject!,
        $removeSamples: Boolean!,
        $sceneCategories: String!,
        $premiumSceneSize: Int!,
      ) {
        ${this.moduleName} {
          ${operation}(
            designStructure: $designStructure,
            assets: $assets,
            removeSamples: $removeSamples,
            sceneCategories: $sceneCategories,
            premiumSceneSize: $premiumSceneSize,
          )
        }
      }
    `;

    const gqlRequest = {
      query,
      variables: {
        designStructure,
        assets: {}, // Empty - API extracts from designStructure
        removeSamples,
        sceneCategories,
        premiumSceneSize,
      },
    };

    const operationName = `${this.moduleName}:${operation}`;
    const response = await graphqlClient.query<any>(gqlRequest, operationName);

    if (response && response[this.moduleName] && response[this.moduleName][operation]) {
      return response[this.moduleName][operation] as DesignPreviews;
    }

    return null;
  }
}

const designRendersService = new DesignRendersService();

export default designRendersService;
